/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``msg-plus-circle.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const MsgPlusCircleIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M2.24973 8.625C2.24973 4.68997 5.4397 1.5 9.37473 1.5C13.3098 1.5 16.4997 4.68997 16.4997 8.625C16.4997 12.56 13.3098 15.75 9.37473 15.75C8.47351 15.75 7.60968 15.5823 6.81397 15.2758C6.74576 15.2495 6.70624 15.2343 6.6771 15.2238C6.67354 15.2225 6.67045 15.2215 6.66783 15.2205C6.66688 15.2206 6.66586 15.2207 6.66477 15.2208C6.64106 15.2226 6.60869 15.2259 6.54677 15.2323L2.706 15.6293C2.69756 15.6302 2.68908 15.6311 2.68059 15.6319C2.51995 15.6486 2.35237 15.6659 2.2122 15.6676C2.07289 15.6692 1.8218 15.6613 1.58104 15.5145C1.29883 15.3423 1.10662 15.0548 1.05545 14.7282C1.0118 14.4496 1.10051 14.2145 1.15528 14.0864C1.21039 13.9575 1.2905 13.8093 1.36729 13.6673L2.60619 11.3741C2.65979 11.2749 2.68844 11.2215 2.70771 11.1818C2.70873 11.1797 2.70966 11.1777 2.71053 11.1759C2.70908 11.1707 2.70733 11.1646 2.70521 11.1574C2.68897 11.1025 2.66399 11.0279 2.62154 10.902C2.38022 10.1861 2.24973 9.42 2.24973 8.625ZM9.37473 3C6.26813 3 3.74973 5.5184 3.74973 8.625C3.74973 9.25499 3.85301 9.85933 4.04297 10.4229C4.04901 10.4408 4.05523 10.4591 4.06157 10.4777C4.12243 10.6566 4.19392 10.8668 4.20896 11.0569C4.22268 11.2302 4.21018 11.3767 4.1673 11.5452C4.12041 11.7295 4.02511 11.9046 3.94781 12.0467C3.94032 12.0605 3.933 12.074 3.92591 12.0871L2.83406 14.1081L6.39254 13.7402C6.40061 13.7394 6.4089 13.7385 6.41737 13.7376C6.50663 13.7283 6.61723 13.7167 6.72578 13.7208C6.825 13.7246 6.9086 13.7357 7.00534 13.758C7.11154 13.7825 7.22675 13.8271 7.32392 13.8647C7.33389 13.8686 7.34366 13.8724 7.35322 13.876C7.97959 14.1174 8.66079 14.25 9.37473 14.25C12.4813 14.25 14.9997 11.7316 14.9997 8.625C14.9997 5.5184 12.4813 3 9.37473 3ZM9.37473 5.625C9.78894 5.625 10.1247 5.96079 10.1247 6.375V7.875H11.6247C12.0389 7.875 12.3747 8.21079 12.3747 8.625C12.3747 9.03921 12.0389 9.375 11.6247 9.375H10.1247V10.875C10.1247 11.2892 9.78894 11.625 9.37473 11.625C8.96052 11.625 8.62473 11.2892 8.62473 10.875V9.375H7.12473C6.71052 9.375 6.37473 9.03921 6.37473 8.625C6.37473 8.21079 6.71052 7.875 7.12473 7.875H8.62473V6.375C8.62473 5.96079 8.96052 5.625 9.37473 5.625Z"
        transform=""
      />
    </g>
  </svg>
);

MsgPlusCircleIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

MsgPlusCircleIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

MsgPlusCircleIcon.displayName = "MsgPlusCircleIcon";

export default MsgPlusCircleIcon;
